<div class="container team-news top-space-only-desktop">
  <div class="row">
    <div class="col-md-7">
      <div class="row ml-0 mr-0">
        <div class="col-12 p-0">
          <div class="tab__header news-page__tabs">
            <a class="tab__item" href="/news/meine" routerLink="/news/meine" routerLinkActive="active">
              <label>Meine News</label>
              <div class="tab__underline"></div>
            </a>
            <a class="tab__item" href="/news" routerLink="/news" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <label>Alle News</label>
              <div class="tab__underline"></div>
            </a>
          </div>
        </div>
      </div>

      <router-outlet *ngIf="!smallScreenSize"></router-outlet>

    </div>
    <div class="col-md-5 d-none d-md-block">
      <div class="row" [class.sticky]="isBrowser">
        <div class="col-md-12">
          <lib-league-table [smallTable]="true"></lib-league-table>
        </div>
        <lib-ad class="col-md-12"></lib-ad>
      </div>
    </div>
  </div>

</div>
 <router-outlet *ngIf="smallScreenSize"></router-outlet>



